import * as React from 'react';

import { cn } from '@savgroup-front-common/primitive/lib/utils';

export function Input({
  className,
  type,
  ...props
}: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'revers-input',
        'h-9 w-full min-w-0 rounded-md border border-border-base-default bg-surface-base-default px-2.5 py-1 text-base stext-base-default shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:stext-base-default placeholder:stext-muted-default focus-visible:border-ring-base-default focus-visible:ring-3 focus-visible:ring-ring-base-default disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-border-danger-default aria-invalid:ring-3 aria-invalid:ring-border-danger-default/20 md:text-sm',
        className,
      )}
      {...props}
    />
  );
}
